import _ from "lodash";
import { Component, useContext, useEffect, useState } from "react";
import { Icon, Label, Table } from "semantic-ui-react";
import { restRequest } from "../../http";
import { JournalizationDetailField } from "../../models/common_model";
import { JournalizationData } from "../../models/journalization_model";
import { formatDateTime, isContentEmpty } from "../../utils";
import '../../assets/scss/components/commons/JournalizationComponent.scss';
import { LanguageContext } from "../../context";

export function JournalizationComponent(props: {
  containerType: number;
  containerId: number;
  detailFields: JournalizationDetailField[];
  renderAddition?: (changedData: any) => any;
  customClassName?: (changedData: any) => string; 
}) {
  const { containerType, containerId, detailFields, renderAddition, customClassName } = props;
  const [data, setData] = useState<JournalizationData[]>([]);
  const [t] = useContext(LanguageContext);

  useEffect(() => {
    restRequest<JournalizationData[]>(
      `journalization/${containerType}/${containerId}`
    ).then(setData);
  }, [containerType, containerId]);

  return (
    <Table striped celled>
      <Table.Header>
        <tr>
          <th>{t('User')}</th>
          <th>{t('Date & Time')}</th>
          <th>{t('Details')}</th>
        </tr>
      </Table.Header>
      <Table.Body>
        {(data || []).map((d) => (
          <tr key={d.id} className={customClassName ? customClassName(d.details) : ''}>
            <td>{d.author && d.author.name}</td>
            <td>{formatDateTime(d.created_at)}</td>
            <td>
              <JournalizationDetailContent
                detailFields={detailFields}
                details={d.details}
              ></JournalizationDetailContent>

              {renderAddition && renderAddition(d.details)}
            </td>
          </tr>
        ))}
      </Table.Body>
    </Table>
  );
}

export function JournalizationDetailContent(props: {
  detailFields: JournalizationDetailField[];
  details: any;
}) {
  return (
    <div>
      {props.detailFields.map((f) => {
        let jd = props.details[f.key];
        if (!jd) {
          return null;
        }

        if (_.isFunction(f.isList) && f.isList(jd) || !_.isFunction(f.isList) && f.isList) {
          return (
            <div key={f.key} style={{display: "flex", flexDirection: "row"}}>
              <div style={{paddingRight: '0.5rem'}}><b>{f.name}: </b></div>
              <div style={{ paddingLeft: "1rem" }}>
                {jd[0] &&
                  jd[0].map((d: any, i: number) => (
                    <div key={"al_" + i}>
                      <Label>
                        <Icon size="small" color="green" name="add" />{" "}
                        {f.formater ? <PromiseText promise={f.formater(d)} /> : d}
                      </Label>{" "}
                      {f.children && (
                        <div style={{ paddingLeft: "1rem" }}>
                          <JournalizationDetailContent
                            detailFields={f.children!}
                            details={d}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                {jd[1] &&
                  jd[1].map((d: any, i: number) => (
                    <div key={"rl_" + i}>
                      <Label>
                        <Icon size="small" color="red" name="minus" />{" "}
                        {f.formater ? <PromiseText promise={f.formater(d)} /> : d}
                      </Label>{" "}
                      {f.children && (
                        <div style={{ paddingLeft: "1rem" }}>
                          <JournalizationDetailContent
                            detailFields={f.children!}
                            details={d}
                          />
                        </div>
                      )}
                    </div>
                  ))}

                {f.children &&
                  jd[2] &&
                  _.keys(jd[2]).map((field) => {
                    const listItemDiff = jd[2][field];

                    return (
                      <div key={field}>
                        <Label>
                          <Icon size="small" color="blue" name="edit" />{" "}
                          {f.childrenKeyFormatter
                            ? f.childrenKeyFormatter(field)
                            : field}
                          :{" "}
                        </Label>{" "}
                        <div style={{ paddingLeft: "1rem" }}>
                          <JournalizationDetailContent
                            detailFields={f.children!}
                            details={listItemDiff}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        } else {
          if (!_.isArray(jd)) {
            jd = [null, jd];
          }

          if (isContentEmpty(jd[0]) && !isContentEmpty(jd[1])) {
            return (
              <div key={f.key} style={{display: "flex", flexDirection: "row"}}>
                <div style={{paddingRight: '0.5rem'}}><b>{f.name}: </b>{" "}</div>
                <div>  
                  <i className="green small add icon"></i>
                  {f.formater ? <PromiseText promise={f.formater(jd[1])} /> : jd[1]}
                </div>
              </div>
            );
          } else if (!isContentEmpty(jd[0]) && isContentEmpty(jd[1])) {
            return (
              <div key={f.key} style={{display: "flex", flexDirection: "row"}}>
                <div style={{paddingRight: '0.5rem'}}><b>{f.name}: </b>{" "}</div>
                <div>
                  <i className="red small minus icon"></i>
                  <div  className="removed_text">
                    {f.formater ? <PromiseText promise={f.formater(jd[0])} /> : jd[0]}
                  </div>
                </div>
              </div>
            );
          }

          return (
            <div key={f.key} style={{display: "flex", flexDirection: "row"}}>
              <div style={{paddingRight: '0.5rem'}}><b>{f.name}:</b>{" "}</div>
              <div>
                {jd[0] != null && (
                  <>
                    {f.formater ? <PromiseText promise={f.formater(jd[0])} /> : jd[0]}{" "}
                    <i className="blue small right arrow icon"></i>
                  </>
                )}{" "}
                {f.formater ? <PromiseText promise={f.formater(jd[1])} /> : jd[1]}
              </div>
            </div>
          );
        }
      })}
    </div>
  );
}


function PromiseText(props: {promise: any}) {
  const text = useState('');

  useEffect(() => {
    Promise.resolve(props.promise).then(data => {
      text[1](data)
    })
  }, []);

  return <>{text[0]}</>;
}